import { dcCrossConnectTypeOptions, currencyOptions } from "@/common/const";
import { includedOptions } from "@/common/const/filter-options";
import quoteCreationTypeOptions from "@/common/const/quote/quoteCreationTypes.const";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const crossConnectQuoteLineFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "select",
    label: "Currency",
    name: "currency",
    required: true,
    readonly: true,
    options: currencyOptions,
  },
  {
    inputType: "text",
    label: "OTE",
    name: "OTE",
    required: true,
  },
  {
    inputType: "text",
    label: "MRE",
    name: "MRE",
    required: true,
  },
  {
    inputType: "select",
    label: "Quote Type",
    required: false,
    readonly: false,
    name: "quoteType",
    options: quoteCreationTypeOptions,
  },
  {
    inputType: "text",
    label: "Provider",
    name: "provider",
    required: true,
  },

  {
    inputType: "select",
    label: "Type",
    name: "DcServiceType",
    required: true,
    options: dcCrossConnectTypeOptions,
  },
  {
    inputType: "text",
    label: "Quantity",
    name: "quantity",
    required: true,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },

  {
    inputType: "select",
    label: "Local Tax/VAT*",
    name: "isLocalTax",
    required: true,

    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Local Tax/VAT (in %)",
    name: "localTax",
    required: true,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: true,
  },
  {
    inputType: "select",
    label: "Network Status",
    name: "networkStatus",
    required: false,
    options: [
      {
        label: "Off Net",
        value: "OfNet",
      },
      {
        label: "Near Net",
        value: "NearNet",
      },
      {
        label: "On Net",
        value: "OnNet",
      },
    ],
  },
  {
    inputType: "select",
    label: "The source of the price",
    name: "source",
    required: false,
    readonly: true,
    options: [
      {
        label: "Manual",
        value: "manual",
      },
      {
        label: "Building List",
        value: "BuildingList",
      },
      {
        label: "Country Coverage",
        value: "CountryCoverage",
      },
    ],
  },
  {
    inputType: "textarea",
    label: "Note",
    name: "description",
    required: false,
  },
];
export default crossConnectQuoteLineFormStrategy;
